import React from 'react';

import ErrorPage from '@app/src/common/components/error-page/ErrorPage';

const NotFound = () => (
  <ErrorPage
    errorCode="404"
    message="error.notFound"
  />
);

export default NotFound;
